/**
 * Shown when the user selects more files than the six-file total cap allows.
 * Copy is fixed per product requirements.
 */

import { ValidationModal } from "@/components/ui/ValidationModal";
import { applicantValidationModalProps } from "@/features/applicant/constants/applicantDialogProps";

export const SIX_FILE_UPLOAD_LIMIT_MESSAGE =
  "The maximum upload limit of six files has been reached. Please ensure that no more than six files are submitted. If you require further assistance, kindly contact us at help@libertyrent.com.";

interface SixFileUploadLimitModalProps {
  isOpen: boolean;
  onClose: () => void;
  /** Optional; defaults to a neutral title */
  title?: string;
}

export function SixFileUploadLimitModal({
  isOpen,
  onClose,
  title = "Upload limit",
}: SixFileUploadLimitModalProps) {
  return (
    <ValidationModal
      {...applicantValidationModalProps}
      isOpen={isOpen}
      title={title}
      message={SIX_FILE_UPLOAD_LIMIT_MESSAGE}
      showValidationIcon={false}
      onClose={onClose}
    />
  );
}
